import {connect} from "react-redux";
import DemandViewer from "./demandViewer";

const mapStateToProps = null;

const mapDispatchToProps = null

export default connect(mapStateToProps, mapDispatchToProps)(DemandViewer);